export enum SearchKind {
  ALL = "ALL",
  ENTRY = "ENTRY",
  TASK = "TASK",
  DEAL = "DEAL",
  MODULE_INSTANCE = "MODULE_INSTANCE",
}
